import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postQuoteAttach } from "../../store/apapUploadAttachments/actions";
export var PostUploadAttachments = function (trigger, id, fileName, pdfFile, code) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseUploadAttach: state.UploadAttach.responseUploadAttach,
        errorUploadAttach: state.UploadAttach.errorUploadAttach,
        loadingUploadAttach: state.UploadAttach.loadingUploadAttach,
    }); }), responseUploadAttach = _a.responseUploadAttach, errorUploadAttach = _a.errorUploadAttach, loadingUploadAttach = _a.loadingUploadAttach;
    useEffect(function () {
        if (trigger) {
            dispatch(postQuoteAttach({
                id: id,
                fileName: fileName,
                pdfFile: pdfFile,
                code: code,
            }));
        }
    }, [trigger, id, fileName, pdfFile]);
    return {
        responseUploadAttach: responseUploadAttach,
        errorUploadAttach: errorUploadAttach,
        loadingUploadAttach: loadingUploadAttach,
    };
};
